import {AfterViewInit, Directive, ElementRef, Input, NgZone, OnDestroy, Renderer2} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {pairwise, tap} from 'rxjs/operators';

@Directive({
    selector: '[pathNameTrimmer]',
})
export class PathNameTrimmerDirective implements AfterViewInit, OnDestroy {

    @Input('flowLog') flowLog: any;
    @Input('pathContainer') pathContainer: HTMLDivElement;
    @Input('pathList') pathList: HTMLUListElement;
    private pathListWidthObserver: ResizeObserver;
    // @ts-ignore
    width$ = new BehaviorSubject<ResizeObserverEntry>();

    constructor(private renderer: Renderer2, private el: ElementRef, private zone: NgZone) {}

    ngAfterViewInit(): void {
        this.pathListWidthObserver = new ResizeObserver(entries => {
            this.zone.run(() => {
                for (const entry of entries) {
                    this.width$.next(entry);
                }
            });
        });
        this.pathListWidthObserver.observe(this.renderer.parentNode(this.el.nativeElement));
        this.pathListWidthObserver.observe(this.renderer.parentNode(this.renderer.parentNode(this.el.nativeElement)));
        this.width$.pipe(
            pairwise(),
            tap(listAndContainerPair => {
                if (listAndContainerPair[0] !== undefined && listAndContainerPair[1] !== undefined) {
                    const pathContainerPair = listAndContainerPair.find(htmlElem => htmlElem?.target['dataset']['type'] === 'pathContainer');
                    const pathListPair = listAndContainerPair.find(htmlElem => htmlElem?.target['dataset']['type'] === 'pathList');
                    this.outputFlowPath(pathContainerPair, pathListPair);
                }
            }),
        ).subscribe();
    }

    ngOnDestroy() {
        this.pathListWidthObserver.unobserve(this.renderer.parentNode(this.el.nativeElement));
        this.pathListWidthObserver.unobserve(this.renderer.parentNode(this.renderer.parentNode(this.el.nativeElement)));
        this.width$.unsubscribe();
    }

    outputFlowPath(pathContainer: ResizeObserverEntry, pathList: ResizeObserverEntry) {
        this.pathList.innerHTML = '';
        const elements = [];
        this.flowLog['details'].path.folders.forEach(folderName => {
            elements.push(this.createKeywordFolderNameLiElement(folderName));
        });
        if (pathList && pathContainer) {
            let pathListWidth = pathList.contentBoxSize[0].inlineSize  < 49 ? 50 : pathList.contentBoxSize[0].inlineSize;
            let pathContainerWidth = pathContainer.contentBoxSize[0].inlineSize < 100 ? 100 : pathContainer.contentBoxSize[0].inlineSize;
            for (const folder of elements) {
                if (pathListWidth / pathContainerWidth < 0.75) {
                    this.renderer.appendChild(this.pathList, folder);
                }
                if (this.renderer.parentNode(folder)) {
                    pathListWidth = this.renderer.parentNode(folder).getBoundingClientRect().width;
                    pathContainerWidth = this.renderer.parentNode(this.renderer.parentNode(folder)).getBoundingClientRect().width;
                }
            }

            const nodeList = this.pathList.querySelectorAll('li');
            nodeList.forEach((element, index) => {
                const box = element.getBoundingClientRect();
                if (box.right > this.pathList.getBoundingClientRect().right) {
                    nodeList.item(index).remove();
                }
            });

            const lastVisibleFolderName = this.pathList.querySelectorAll('li') as unknown as Array<any>;
            if (this.pathList.querySelectorAll('li').length < elements.length) {
                if (!this.pathList.querySelector('.path-ellipsis')) {
                    if (this.pathList && this.pathList.querySelectorAll('li').length - 1
                        && lastVisibleFolderName[this.pathList.querySelectorAll('li').length - 1]) {
                        this.renderer.removeChild(
                            this.pathList,
                            lastVisibleFolderName[this.pathList.querySelectorAll('li').length - 1]
                        );
                    }
                    if (this.pathList && this.pathList.querySelectorAll('li').length - 2
                        && lastVisibleFolderName[this.pathList.querySelectorAll('li').length - 2]) {
                        this.renderer.removeChild(
                            this.pathList,
                            lastVisibleFolderName[this.pathList.querySelectorAll('li').length - 2]
                        );
                    }

                    const ellipsisLi = this.renderer.createElement('li');

                    this.renderer.appendChild(ellipsisLi, this.renderer.createText('...'));
                    this.renderer.addClass(ellipsisLi, 'folder');
                    this.renderer.addClass(ellipsisLi, 'path-ellipsis');

                    const arrowIconSpan = this.renderer.createElement('span');
                    this.renderer.addClass(arrowIconSpan, 'arrow-icon');
                    this.renderer.appendChild(ellipsisLi, arrowIconSpan);

                    this.renderer.appendChild(this.pathList, ellipsisLi);
                    this.renderer.appendChild(this.pathList, elements[elements.length - 1]);
                }
            }
        }

    }

    createKeywordFolderNameLiElement(folderName): HTMLLIElement {
        const folderIconSpan = this.renderer.createElement('span');
        this.renderer.addClass(folderIconSpan, 'folder-icon');
        const text = this.renderer.createText(folderName);
        const arrowIconSpan = this.renderer.createElement('span');
        this.renderer.addClass(arrowIconSpan, 'arrow-icon');
        const liElement: HTMLLIElement = this.renderer.createElement('li');
        this.renderer.addClass(liElement, 'folder');
        this.renderer.appendChild(liElement, folderIconSpan);
        this.renderer.appendChild(liElement, text);
        this.renderer.appendChild(liElement, arrowIconSpan);
        return liElement;
    }

}
